module.exports = __webpack_public_path__ + "img/cl-install-hp-reset_12200.83b9c3dd.png";